import { useEffect, useState } from 'react';
import './App.css';
import TowerGlobe from './TowerGlobe';

/** 合作伙伴：src/assets/partner-sprite.png（10×104px 横排 PNG 精灵图，保留透明；源见 public/partner/，重跑 scripts/build-partner-sprite.py） */
const PARTNER_LOGO_COUNT = 10;
const partnerRowTop = Array.from({ length: PARTNER_LOGO_COUNT }, (_, i) => i);
const partnerRowBottom = [...partnerRowTop].reverse();

const pageAnchors = ['home', 'about', 'services', 'tower', 'industry', 'partners', 'contact'];

const LANG_STORAGE_KEY = 'oceantrack-lang';

function readStoredLang() {
  try {
    const s = localStorage.getItem(LANG_STORAGE_KEY);
    if (s === 'en' || s === 'zh') return s;
  } catch {
    /* ignore */
  }
  return 'zh';
}

const copy = {
  zh: {
    htmlLang: 'zh-CN',
    langLabelZh: '中',
    langLabelEn: 'EN',
    brandTitle: '青岛欧信捷供应链有限公司',
    brandTagline: '全球互联，航运万里',
    sideAnchors: {
      home: '首页',
      about: '关于我们',
      services: '物流服务',
      tower: '控制塔',
      industry: '行业方案',
      partners: '合作伙伴',
      contact: '联系我们',
    },
    nav: ['关于我们', '物流服务', '控制塔', '行业方案', '合作伙伴', '联系我们'],
    partnersTitle: '合作伙伴',
    heroEyebrow: '同心同行，通达全球',
    heroTitle: '全球航海物流与国际货运代理',
    heroDesc: '提供覆盖海运、空运、报关、仓储与末端配送的一站式国际供应链服务。',
    ctaQuote: '获取报价',
    ctaContact: '在线咨询',
    aboutTitle: '国际物流与国际货运代理综合服务商',
    aboutEyebrow: '关于我们',
    aboutBody:
      '采用简洁模块与全屏叙事，突出企业定位、服务承诺与网络能力，便于您后续替换为自有品牌与案例内容。',
    aboutBullets: [
      '10 秒在线响应，24 小时专人跟进',
      '海运 / 空运 / 报关 / 仓配一体化服务',
      '全国多港口与机场服务网络覆盖',
      '全链路可视化追踪与异常预警',
    ],
    aboutImageAlt: '物流仓储与运输场景',
    servicesTitle: '物流服务',
    servicesDesc: '',
    serviceGridBlurb: '高标准 SOP + 可视化追踪，支持跨区域协同与多节点交付。',
    towerTitle: '全球供应链控制塔',
    towerDesc: '根据北美-欧洲-亚洲航线板块，展示集装箱干线与全球节点动态。',
    towerHudChip: '集装箱干线',
    towerHudTagline: '跨太平洋 · 欧亚 · 北美西岸',
    industryTitle: '无论您从事什么行业，我们都是您的全球货运代理',
    feedTitle: '实时事件流',
    towerFeedItems: [
      '上海港 -> 洛杉矶港 ETA 更新 +2h',
      '新加坡中转仓完成批次分拣',
      '鹿特丹到汉堡冷链运输已启程',
      '迪拜项目件完成清关，进入陆运阶段',
    ],
    industryCards: [
      { name: '再生能源', desc: '面向风电、光伏与水电项目，提供设备运输、场站配送与节点联动，保障项目安全按期落地。', icon: 'wind' },
      { name: '发电', desc: '围绕发电工程核心设备，提供高时效运输与多环节协同，确保机组建设与并网计划稳步推进。', icon: 'power' },
      { name: '汽车', desc: '覆盖整车及零部件物流链路，通过精准排程与库存协同，支撑产线连续运转与交付提速。', icon: 'auto' },
      { name: '造纸', desc: '服务造纸产线建设与技改场景，保障机械设备、浆料与成品在各节点间高效周转。', icon: 'paper' },
      { name: '工业制造', desc: '针对大型制造项目提供重件运输、现场统筹与进度协同，降低复杂交付过程中的不确定性。', icon: 'factory' },
      { name: '危化品', desc: '依据危化品规范开展分级运输与全程监控，在安全合规前提下保障交付时效与稳定性。', icon: 'hazard' },
    ],
    serviceTitles: ['国际海运', '国际空运', '跨境陆运', '项目运输', '合同物流', '报关与保险'],
    showcaseBanners: [
      {
        id: 'banner-ocean',
        title: '国际海运整箱/拼箱',
        image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1200&q=80',
      },
      {
        id: 'banner-air',
        title: '国际空运快线',
        image: 'https://images.unsplash.com/photo-1565891741441-64926e441838?auto=format&fit=crop&w=1200&q=80',
      },
      {
        id: 'banner-customs',
        title: '报关仓储与集卡运输',
        image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80',
      },
    ],
    showcaseStripTagline: '快速 · 高效 · 周全',
    mediaServices: [
      {
        id: 'media-ocean',
        title: '海运服务',
        desc: '提供全球港口整箱/拼箱与散货船方案，支持门到门交付。',
        image: 'https://images.unsplash.com/photo-1565891741441-64926e441838?auto=format&fit=crop&w=900&q=80',
      },
      {
        id: 'media-air',
        title: '空运服务',
        desc: '高时效航线组合，覆盖亚太、欧洲、美洲主要枢纽机场。',
        image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=900&q=80',
      },
      {
        id: 'media-customs',
        title: '清关报关',
        desc: '标准化单证流程与专业关务团队，减少异常与通关延迟。',
        image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80',
      },
      {
        id: 'media-warehouse',
        title: '仓配运输',
        desc: '仓储管理+末端配送一体化，提升库存周转与履约效率。',
        image: 'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=900&q=80',
      },
    ],
    contactCard: {
      modalTitle: '联系方式',
      close: '关闭',
      companyZh: '青岛欧信捷供应链有限公司',
      companyEn: 'QINGDAO OCEANTRACK SUPPLY CHAIN CO., LTD.',
      addressLabel: '地址：',
      address: '青岛市市北区龙城路31号卓越世纪中心TOWER3 1101',
      emailLabel: '邮箱：',
      email: 'evan@oceantrack.com.cn',
      phoneLabel: '电话：',
      zipLabel: '邮编：',
      zip: '266000',
    },
    footer: {
      cols: [
        {
          title: '关于我们',
          links: ['公司简介', '发展里程碑', '核心能力', '绿色发展', '企业视频'],
        },
        {
          title: '物流服务',
          links: ['海运整箱/拼箱', '空运服务', '报关仓储', '项目运输', '服务申请'],
        },
        {
          title: '国际运输',
          links: ['国际海运', '保险服务', '特种运输', '医疗供应链', '危险品运输'],
        },
        {
          title: '支持中心',
          links: ['货物追踪', '新闻资讯', '联系我们', '工作机会', '下载中心'],
        },
      ],
      contactCompany: '青岛欧信捷供应链有限公司',
      contactAddress: '青岛市市北区卓越世纪中心3号楼1101室',
      contactEmail: 'op01@oceaantrack.com.cn',
      contactRegLabel: '税务登记号/营业执照号：',
      contactRegNo: '91370213MAEEUF149T',
      legalLeft: '© 2026 青岛欧信捷供应链有限公司 版权所有',
      legalMiddle: '备案号：91370213MAEEUF149T',
      legalLinks: ['Standard Trading Conditions', 'US OBL Terms & Condition', 'Air Waybill Terms & Condition'],
    },
  },
  en: {
    htmlLang: 'en',
    langLabelZh: '中',
    langLabelEn: 'EN',
    brandTitle: 'Qingdao Oceantrack Supply Chain Co., Ltd.',
    brandTagline: 'A world, one ocean network',
    sideAnchors: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      tower: 'Control Tower',
      industry: 'Industries',
      partners: 'Partners',
      contact: 'Contact',
    },
    nav: ['About', 'Services', 'Control Tower', 'Industries', 'Partners', 'Contact'],
    partnersTitle: 'Partners',
    heroEyebrow: 'A world, one team',
    heroTitle: 'Global Maritime Logistics and Freight Forwarding',
    heroDesc: 'One-stop international supply chain services across ocean freight, air freight, customs, warehousing and delivery.',
    ctaQuote: 'Get Quote',
    ctaContact: 'Contact Us',
    aboutTitle: 'Integrated International Logistics Solutions',
    aboutEyebrow: 'About us',
    aboutBody:
      'Clean modules and full-screen storytelling highlight who you are, what you promise, and where you operate—ready for your own brand and case studies.',
    aboutBullets: [
      'Online response in seconds, dedicated follow-up within 24 hours',
      'Ocean / air / customs / warehousing in one integrated service',
      'Nationwide coverage across major ports and airports',
      'End-to-end visibility with exception alerts',
    ],
    aboutImageAlt: 'Logistics warehousing and transport',
    servicesTitle: 'Logistics Services',
    servicesDesc: 'Modular sections that can be replaced with your own content and images.',
    serviceGridBlurb: 'High-standard SOPs and live tracking for multi-region, multi-node delivery.',
    towerTitle: 'Global Supply Chain Control Tower',
    towerDesc: 'Container liner services and global nodes across North America, Europe and Asia.',
    towerHudChip: 'Container lanes',
    towerHudTagline: 'Trans-Pacific · Europe–Asia · US West Coast',
    industryTitle: 'No matter your industry, we are your global freight partner',
    feedTitle: 'Live Event Stream',
    towerFeedItems: [
      'Shanghai -> Los Angeles ETA update +2h',
      'Singapore hub completed batch sorting',
      'Rotterdam–Hamburg reefer leg departed',
      'Dubai project cargo cleared; entering road leg',
    ],
    industryCards: [
      { name: 'Renewables', desc: 'Wind, solar and hydro projects: equipment moves, site delivery and milestone coordination for safe, on-time execution.', icon: 'wind' },
      { name: 'Power Generation', desc: 'High-priority transport and multi-party alignment around core power equipment and commissioning schedules.', icon: 'power' },
      { name: 'Automotive', desc: 'Full vehicle and parts chains with scheduling and inventory sync to keep lines running and deliveries fast.', icon: 'auto' },
      { name: 'Paper', desc: 'Mill builds and retrofits—machinery, pulp and finished rolls moving efficiently between every node.', icon: 'paper' },
      { name: 'Industrial Manufacturing', desc: 'Heavy lifts, site orchestration and progress coordination to reduce uncertainty on complex deliveries.', icon: 'factory' },
      { name: 'Dangerous Goods', desc: 'TDG-aligned transport and monitoring—safe, compliant, and reliable service levels.', icon: 'hazard' },
    ],
    serviceTitles: ['Ocean Freight', 'Air Freight', 'Cross-border Road', 'Project Cargo', 'Contract Logistics', 'Customs & Insurance'],
    showcaseBanners: [
      {
        id: 'banner-ocean',
        title: 'Ocean FCL / LCL',
        image: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=1200&q=80',
      },
      {
        id: 'banner-air',
        title: 'Air Freight Express',
        image: 'https://images.unsplash.com/photo-1565891741441-64926e441838?auto=format&fit=crop&w=1200&q=80',
      },
      {
        id: 'banner-customs',
        title: 'Customs, warehouse & trucking',
        image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80',
      },
    ],
    showcaseStripTagline: 'Fast · Reliable · Thorough',
    mediaServices: [
      {
        id: 'media-ocean',
        title: 'Ocean services',
        desc: 'FCL / LCL and bulk options worldwide with door-to-door programs.',
        image: 'https://images.unsplash.com/photo-1565891741441-64926e441838?auto=format&fit=crop&w=900&q=80',
      },
      {
        id: 'media-air',
        title: 'Air freight',
        desc: 'Time-definite lane combinations across Asia-Pacific, Europe and the Americas.',
        image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=900&q=80',
      },
      {
        id: 'media-customs',
        title: 'Customs clearance',
        desc: 'Standardized documentation and seasoned brokers to cut dwell time and surprises.',
        image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&q=80',
      },
      {
        id: 'media-warehouse',
        title: 'Warehousing & distribution',
        desc: 'WMS plus last-mile in one stack for better turns and on-time fulfillment.',
        image: 'https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=900&q=80',
      },
    ],
    contactCard: {
      modalTitle: 'Contact',
      close: 'Close',
      companyZh: '青岛欧信捷供应链有限公司',
      companyEn: 'QINGDAO OCEANTRACK SUPPLY CHAIN CO., LTD.',
      addressLabel: 'Add: ',
      address: 'Room 1101, Tower 3, Excellence Century Center, No. 31 Longcheng Road, Shibei District, Qingdao City',
      emailLabel: 'E-mail: ',
      email: 'evan@oceantrack.com.cn',
      phoneLabel: 'TEL: ',
      zipLabel: 'Zip code: ',
      zip: '266000',
    },
    footer: {
      cols: [
        {
          title: 'About',
          links: ['Company Profile', 'Milestones', 'Core Strengths', 'Sustainability', 'Company Video'],
        },
        {
          title: 'Logistics Service',
          links: ['Ocean FCL/LCL', 'Air Freight', 'Customs & Warehouse', 'Project Cargo', 'Service Request'],
        },
        {
          title: 'International Freight',
          links: ['Ocean Freight', 'Cargo Insurance', 'Special Cargo', 'Healthcare Supply Chain', 'Dangerous Goods'],
        },
        {
          title: 'Support Center',
          links: ['Track & Trace', 'News', 'Contact Us', 'Job Opportunities', 'Downloads'],
        },
      ],
      contactCompany: 'Qingdao Oceantrack Supply Chain Co., Ltd.',
      contactAddress: 'Room 1101, Tower 3, Excellence Century Center, Shibei District, Qingdao',
      contactEmail: 'op01@oceaantrack.com.cn',
      contactRegLabel: 'Reg. / business license no.: ',
      contactRegNo: '91370213MAEEUF149T',
      legalLeft: '© 2026 Qingdao Oceantrack Supply Chain Co., Ltd. All rights reserved.',
      legalMiddle: 'Registration No.: 91370213MAEEUF149T',
      legalLinks: ['Standard Trading Conditions', 'US OBL Terms & Condition', 'Air Waybill Terms & Condition'],
    },
  },
};

const heroBannerImage = '/hero-ship-3k.jpg';

/** 公司 Logo：public/logo.jpg */
const COMPANY_LOGO = '/logo.jpg';

/** 名片联系人：获取报价 vs 在线咨询（姓名、电话不同；职务与展示语言一致用英文） */
const CONTACT_CARD_BY_VARIANT = {
  quote: {
    name: 'Evan Yi',
    title: 'Deputy General Manager',
    phone: '+86-176 6418 5319',
  },
  consult: {
    name: 'Andy Sun',
    title: 'Deputy General Manager',
    phone: '+86-178 0628 6820',
  },
};

function IndustryIcon({ type }) {
  const common = {
    viewBox: '0 0 64 64',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: '2.4',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className: 'icon-svg',
    'aria-hidden': true,
  };

  if (type === 'auto') {
    return (
      <svg {...common}>
        <path d="M10 39v-4l5-10a6 6 0 0 1 5.4-3.5h19.2a6 6 0 0 1 4.6 2.1l7.8 9.4H54a3 3 0 0 1 3 3v7H10z" />
        <path d="M21 26h12m4 0h4l4 5" />
        <circle cx="20" cy="43" r="4.2" />
        <circle cx="46" cy="43" r="4.2" />
      </svg>
    );
  }
  if (type === 'power') {
    return (
      <svg {...common}>
        <path d="M35 8 21 33h10l-2 23 14-25H33z" />
        <path d="M12 50h40" />
      </svg>
    );
  }
  if (type === 'paper') {
    return (
      <svg {...common}>
        <path d="M18 14h20l8 8v28H18z" />
        <path d="M38 14v10h10M24 30h16M24 37h16M24 44h12" />
      </svg>
    );
  }
  if (type === 'chip') {
    return (
      <svg {...common}>
        <rect x="19" y="19" width="26" height="26" rx="3" />
        <path d="M25 25h14v14H25zM32 11v8m0 26v8M11 32h8m26 0h8M18 18l-5-5m38 38l-5-5m0-28l5-5M13 51l5-5" />
      </svg>
    );
  }
  if (type === 'health') {
    return (
      <svg {...common}>
        <path d="M32 50s-16-9-16-22c0-6 4-10 9-10 3 0 6 2 7 5 1-3 4-5 7-5 5 0 9 4 9 10 0 13-16 22-16 22z" />
        <path d="M14 34h12l3-6 5 12 3-6h13" />
      </svg>
    );
  }
  if (type === 'wind') {
    return (
      <svg {...common}>
        <path d="M32 10v26m0 0l-11 6m11-6l11 6m-11-6l3-18M32 36v14" />
        <circle cx="32" cy="36" r="2.5" />
      </svg>
    );
  }
  if (type === 'factory') {
    return (
      <svg {...common}>
        <path d="M10 50V26h14v8l11-8v24M44 50V18h10v32M10 50h44" />
        <path d="M18 42h4m6 0h4m6 0h4m10 0h0" />
      </svg>
    );
  }
  if (type === 'hazard') {
    return (
      <svg {...common}>
        <path d="M32 10 52 46H12z" />
        <path d="M32 23v11m0 6h.01" />
        <path d="M20 52h24" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path d="M24 16h16l10 18-10 18H24L14 34z" />
      <path d="M26 34h12m-6-8v16" />
    </svg>
  );
}

function App() {
  const [activeAnchor, setActiveAnchor] = useState('home');
  const [lang, setLang] = useState(readStoredLang);
  const [contactCardVariant, setContactCardVariant] = useState(null);
  const t = copy[lang];
  const cc = t.contactCard;
  const contactCardPerson = contactCardVariant ? CONTACT_CARD_BY_VARIANT[contactCardVariant] : null;

  useEffect(() => {
    document.documentElement.lang = copy[lang].htmlLang;
    try {
      localStorage.setItem(LANG_STORAGE_KEY, lang);
    } catch {
      /* ignore */
    }
  }, [lang]);

  useEffect(() => {
    const updateActive = () => {
      const sections = pageAnchors
        .map((item) => document.getElementById(item))
        .filter(Boolean);

      let current = 'home';
      for (const section of sections) {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.38) {
          current = section.id;
        }
      }
      setActiveAnchor(current);
    };

    updateActive();
    window.addEventListener('scroll', updateActive, { passive: true });
    return () => window.removeEventListener('scroll', updateActive);
  }, []);

  useEffect(() => {
    if (!contactCardVariant) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setContactCardVariant(null);
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [contactCardVariant]);

  return (
    <div className="site">
      <aside className="side-anchor">
        {pageAnchors.map((item) => (
          <a
            key={item}
            href={`#${item}`}
            className={activeAnchor === item ? 'active' : ''}
            aria-label={t.sideAnchors[item]}
          >
            <span />
          </a>
        ))}
      </aside>

      <header className="topbar">
        <div className="brand">
          <div className="brand-mark">
            <img src={COMPANY_LOGO} alt={t.brandTitle} width={120} height={120} decoding="async" />
          </div>
          <div>
            <h1>{t.brandTitle}</h1>
            <p>{t.brandTagline}</p>
          </div>
        </div>
        <nav>
          <a href="#about">{t.nav[0]}</a>
          <a href="#services">{t.nav[1]}</a>
          <a href="#tower">{t.nav[2]}</a>
          <a href="#industry">{t.nav[3]}</a>
          <a href="#partners">{t.nav[4]}</a>
          <a href="#contact">{t.nav[5]}</a>
        </nav>
        <div className="lang-switch">
          <button type="button" className={lang === 'zh' ? 'active' : ''} onClick={() => setLang('zh')}>
            {t.langLabelZh}
          </button>
          <button type="button" className={lang === 'en' ? 'active' : ''} onClick={() => setLang('en')}>
            {t.langLabelEn}
          </button>
        </div>
      </header>

      <section className="screen-section hero hero-video" id="home">
        <div className="hero-image-bg" style={{ backgroundImage: `url(${heroBannerImage})` }} />
        <div className="hero-video-overlay" />
        <div className="hero-inner">
          <div className="hero-content">
            <p className="eyebrow">{t.heroEyebrow}</p>
            <h2>{t.heroTitle}</h2>
            <p>{t.heroDesc}</p>
            <div className="hero-actions">
              <button type="button" onClick={() => setContactCardVariant('quote')}>
                {t.ctaQuote}
              </button>
              <button type="button" className="ghost" onClick={() => setContactCardVariant('consult')}>
                {t.ctaContact}
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="screen-section about-section" id="about">
        <div className="hero-strip">
          {t.showcaseBanners.map((item) => (
            <article key={item.id} className="strip-card" style={{ backgroundImage: `url(${item.image})` }}>
              <div className="strip-mask">
                <h4>{item.title}</h4>
                <p>{t.showcaseStripTagline}</p>
              </div>
            </article>
          ))}
        </div>
        <div className="one-stop">
          <div className="one-stop-image">
            <img
              src="https://images.unsplash.com/photo-1494412651409-8963ce7935a7?auto=format&fit=crop&w=1400&q=80"
              alt={t.aboutImageAlt}
            />
          </div>
          <div className="one-stop-content">
            <p className="eyebrow">{t.aboutEyebrow}</p>
            <h3>{t.aboutTitle}</h3>
            <p>{t.aboutBody}</p>
            <ul>
              {t.aboutBullets.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="screen-section media-services" id="services">
        <h3>{t.servicesTitle}</h3>
        <p>{t.servicesDesc}</p>
        <div className="media-grid">
          {t.mediaServices.map((item) => (
            <article key={item.id}>
              <img src={item.image} alt={item.title} />
              <div className="media-body">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
        <div className="service-grid">
          {t.serviceTitles.map((item) => (
            <article key={item}>
              <h4>{item}</h4>
              <p>{t.serviceGridBlurb}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="screen-section tower" id="tower">
        <div className="tower-header">
          <h3>{t.towerTitle}</h3>
          <p>{t.towerDesc}</p>
        </div>
        <div className="tower-board">
          <div className="tower-globe-panel">
            <TowerGlobe />
            <div className="tower-hud tower-hud-luxury tower-hud-globe">
              <div className="hud-chip hud-chip-luxury">{t.towerHudChip}</div>
              <div className="hud-divider hud-divider-luxury" />
              <div className="hud-text hud-text-luxury">{t.towerHudTagline}</div>
            </div>
          </div>
          <div className="board-feed board-feed-luxury">
            <h4>{t.feedTitle}</h4>
            <ul>
              {t.towerFeedItems.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="screen-section industry" id="industry">
        <h3>{t.industryTitle}</h3>
        <div className="industry-grid">
          {t.industryCards.map((item) => (
            <article key={item.name}>
              <div className="icon">
                <IndustryIcon type={item.icon} />
              </div>
              <h4>{item.name}</h4>
              <p>{item.desc}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="screen-section partners-section" id="partners">
        <h3 className="partners-title">{t.partnersTitle}</h3>
        <div className="partners-marquee" aria-label={t.partnersTitle}>
          <div className="partners-marquee-row partners-marquee-row--left">
            <div className="partners-marquee-mask">
              <div className="partners-marquee-track">
                {[...partnerRowTop, ...partnerRowTop].map((spriteIndex, i) => (
                  <div
                    key={`top-${spriteIndex}-${i}`}
                    className={`partners-marquee-cell ${i % 2 === 0 ? 'cell-light' : 'cell-gray'}`}
                  >
                    <span
                      className="partners-marquee-sprite"
                      style={{ '--partner-sprite-index': spriteIndex }}
                      aria-hidden
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="partners-marquee-row partners-marquee-row--right">
            <div className="partners-marquee-mask">
              <div className="partners-marquee-track">
                {[...partnerRowBottom, ...partnerRowBottom].map((spriteIndex, i) => (
                  <div
                    key={`bot-${spriteIndex}-${i}`}
                    className={`partners-marquee-cell ${i % 2 === 0 ? 'cell-gray' : 'cell-light'}`}
                  >
                    <span
                      className="partners-marquee-sprite"
                      style={{ '--partner-sprite-index': spriteIndex }}
                      aria-hidden
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="screen-section" id="contact">
        <div className="footer-sitemap">
          {t.footer.cols.map((col) => (
            <section key={col.title} className="footer-col">
              <h5>{col.title}</h5>
              {col.links.map((item) => (
                <a key={item} href="#contact">
                  {item}
                </a>
              ))}
            </section>
          ))}
        </div>
        <div className="footer-contact">
          <div className="footer-contact-row">
            <span>{t.footer.contactCompany}</span>
            <span className="footer-contact-dot" aria-hidden>
              ·
            </span>
            <span>{t.footer.contactAddress}</span>
          </div>
          <div className="footer-contact-row">
            <span>{t.footer.contactEmail}</span>
            <span className="footer-contact-dot" aria-hidden>
              ·
            </span>
            <span>
              {t.footer.contactRegLabel}
              {t.footer.contactRegNo}
            </span>
          </div>
        </div>
        <div className="footer-legal">
          <div>{t.footer.legalLeft}</div>
          <div>{t.footer.legalMiddle}</div>
          <div className="footer-legal-links">
            {t.footer.legalLinks.map((item) => (
              <a key={item} href="#contact">
                {item}
              </a>
            ))}
          </div>
        </div>
      </footer>

      {contactCardVariant ? (
        <div
          className="contact-card-backdrop"
          role="dialog"
          aria-modal="true"
          aria-labelledby="contact-card-heading"
          onClick={(e) => {
            if (e.target === e.currentTarget) setContactCardVariant(null);
          }}
        >
          <div className="contact-card-panel">
            <button
              type="button"
              className="contact-card-close"
              onClick={() => setContactCardVariant(null)}
              aria-label={cc.close}
            >
              ×
            </button>

            <div className="contact-card-header">
              <div className="contact-card-header-text">
                <h2 id="contact-card-heading" className="contact-card-company-zh">
                  {cc.companyZh}
                </h2>
                <p className="contact-card-company-en">{cc.companyEn}</p>
              </div>
            </div>

            <div className="contact-card-middle">
              <div className="contact-card-logo-wrap">
                <img
                  src={COMPANY_LOGO}
                  alt={cc.companyZh}
                  className="contact-card-side-logo"
                  width={200}
                  height={120}
                  decoding="async"
                />
              </div>
              <div className="contact-card-person">
                <p className="contact-card-name">{contactCardPerson.name}</p>
                <p className="contact-card-title">{contactCardPerson.title}</p>
              </div>
            </div>

            <div className="contact-card-divider" aria-hidden />

            <div className="contact-card-footer">
              <p>
                <span className="contact-card-label">{cc.addressLabel}</span>
                {cc.address}
              </p>
              <p>
                <span className="contact-card-label">{cc.emailLabel}</span>
                <a href={`mailto:${cc.email}`}>{cc.email}</a>
              </p>
              <p>
                <span className="contact-card-label">{cc.phoneLabel}</span>
                <a href={`tel:${contactCardPerson.phone.replace(/[\s-]/g, '')}`}>{contactCardPerson.phone}</a>
              </p>
              <p>
                <span className="contact-card-label">{cc.zipLabel}</span>
                {cc.zip}
              </p>
              <span className="contact-card-eco" aria-hidden>
                ♻
              </span>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default App;
